import { mustGetElementById } from "./helpers";
import { useProxyDisplay } from "./useProxyDisplay";

const getResponseMsg = () => mustGetElementById<HTMLParagraphElement>('responseMsg');

export function useResponseProxy() {
  const responseMsg = useProxyDisplay(getResponseMsg);

  return { responseMsg };
}
